import { EventsComponent } from './../events/events.component';
import * as bowser from 'bowser';
import {
	ChangeDetectorRef,
	Component,
	DoCheck,
	ElementRef,
	HostBinding,
	Injector,
	Input,
	OnInit,
	ViewChild,
} from '@angular/core';
import { formatNumberWithCommas } from '../../../Utils/utils';
import { includes, isEmpty } from 'lodash';

@Component({
	selector: 'unmasked-input',
	host: { '[class]': 'myCustomClass' },
	template: `
		<form name="maskedInputForm" [ngClass]="{ error: error, disabled: control.disabled }">
			<label *ngIf="control.attributes && control.attributes.label">{{ control.attributes.label }}</label>
			<label
				[for]="control.name.split('PolicyData.').join('')"
				[attr.aria-labelledby]="control.attributes.placeholder"
				[attr.aria-describedby]="control.attributes.placeholder"
				class="input-inner-label"
				*ngIf="value"
			>
				{{ control.attributes.placeholder }}</label
			>
			<input
				gtm-handler
				[attr.gtm]="gaLabel"
				events="focus"
				handlerType="dataValue"
				[label]="gaLabel"
				action="TextBoxFocus"
				[attr.id]="control.name.split('PolicyData.').join('')"
				#masked
				*ngIf="!isMobile"
				[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
				class="masked-input"
				[ngClass]="assignClass(control)"
				[(ngModel)]="value"
				name="maskedInput"
				placeholder="{{ control.attributes.placeholder }}"
				type="text"
				(blur)="onBlur()"
				(focus)="focusFunction('TextBoxFocus', '')"
				(click)="focusFunction('TextBoxFocus', '')"
				(ngModelChange)="onChange($event)"
				[disabled]="control.disabled"
				minlength="{{ control.attributes.minlength }}"
				maxlength="{{ calculatedMaxlength }}"
				autocomplete="off"
			/>
			<input
				model-formatter
				gtm-handler
				#masked
				[label]="gaLabel"
				[attr.gtm]="gaLabel"
				*ngIf="isMobile"
				class="masked-input"
				action="TextBoxFocus"
				events="focus"
				handlerType="dataValue"
				[ngClass]="assignClass(control)"
				[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
				[(ngModel)]="value"
				name="maskedInput"
				placeholder="{{ control.attributes.placeholder }}"
				[attr.type]="inputType"
				[attr.pattern]="inputPattern"
				[attr.inputmode]="inputMode"
				(input)="onNumberInput($event)"
				(focus)="focusFunction('TextBoxFocus', '')"
				(click)="focusFunction('TextBoxFocus', '')"
				(blur)="onBlur()"
				[disabled]="control.disabled"
				minlength="0"
				maxlength="{{ calculatedMaxlength }}"
				(keyup.enter)="keypadClose()"
				(ngModelChange)="onChange($event)"
				autocomplete="off"
			/>

			<div *ngIf="error" class="error-container">
				<div class="error">
					<i class="error-icon"></i>
				</div>
			</div>
		</form>
	`,
	styleUrls: ['./unmasked-input.component.scss'],
})
export class UnMaskedComponent extends EventsComponent implements OnInit, DoCheck {
	@Input() context: any;
	@ViewChild('masked', { static: true }) maskedInput;
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';

	restrictPatternRegex: RegExp;
	oldValue: any;
	inputType: any;
	inputPattern: string;
	inputMode: string;
	calculatedMaxlength: any;
	answerDebounce: any;

	constructor(injector: Injector, private el: ElementRef, private ref: ChangeDetectorRef) {
		super(injector);
		this.el = el;
	}

	async ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.value = !isEmpty(this.value) ? this.value + '' : this.value;
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
		// this.el.nativeElement.classList.add(`col-${this.control.width}`);
		// this.el.nativeElement.classList.add(`col-${this.control.attributes.class}`);
		if (this.control.attributes) {
			this.el.nativeElement.classList.add(`${this.control.attributes.class}`);
		}
		if (this.control.attributes.groupDigits && !this.isMobile) {
			//maybe we dont need this
			this.groupDigits();
			this.addDollar();
		}
		setTimeout(() => {
			const inputControl = this.el.nativeElement.querySelector('input');
			if (inputControl) {
				if (this.control.attributes && this.control.attributes.type === 'number') {
					const allowedChars = [8, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
					inputControl.addEventListener('textInput', (event) => {
						// todo add on event i have error now
						const char = event.data;
						const keyCode = char.charCodeAt(0);

						// Prevent from typing invalid characters
						if (!includes(allowedChars, keyCode)) {
							event.preventDefault();
						}
					});
				}
			}
		}, 500);

		this.restrictPatternRegex = new RegExp(this.control.attributes.pattern, 'g');
		this.calculatedMaxlength = this.control.attributes.maxlength;
		this.inputType = 'text';
		if (this.control.attributes) {
			this.el.nativeElement.classList.add(`${this.control.attributes.class}`);

			if (this.control.attributes.type && this.control.attributes.type.length > 0) {
				this.inputType = this.control.attributes.type;
			} else {
				if (this.control.attributes.pattern !== undefined) {
					this.restrictPattern();
				}
			}

			if (
				this.isMobile &&
				this.control.attributes.DynamicMobileKeyboard &&
				this.control.attributes.mobileKeyboardType
			) {
				this.applyMobileKeyboardAttributes(this.control.attributes.mobileKeyboardType);
			}
		}
	}

	applyMobileKeyboardAttributes(mobileKeyboardType) {
		switch (mobileKeyboardType) {
			case 'numeric':
				this.inputPattern = '\\d*';
				this.inputMode = 'numeric';
				break;

			case 'decimal':
				this.inputType = 'text';
				this.inputMode = 'decimal';
				break;

			case 'email':
				this.inputMode = 'email';
				break;
		}
	}

	//maybe we dont need this
	ngDoCheck() {
		if (this.control && this.control.attributes && this.control.attributes.groupDigits && !this.isMobile) {
			this.groupDigits();
		}
	}

	updateSplunk(action: string, value: any) {
		const label = this.control.title ? this.control.title : this.control.attributes.labelForSplunk;
		this.splunkAnalyticsService.publish(action, label || '', value);
	}

	focusFunction(action: string, value: any) {
		this.updateSplunk(action, value);

		this.removeMiddleNameError();
	}

	onBlur() {
		let val = this.value;
		if (val && this.inputType === 'text') {
			while (val[0] === ' ') {
				val = val.replace(val[0], '');
			}
			val = val.replace(/\s*$/, '');
		}
		this.value = val;
		this.updateAnswer(true);
		this.storeService.policyDataSubject.next();
	}

	onChange(event) {
		// const event = eventData.target.value;
		/*
    Call restrictPattern function if one of these two
    takes place: either old value not equals to the current
    one or the 'event' contains alphabetical characters
    */
		if (event.indexOf(',') === -1 && event.length > this.calculatedMaxlength) {
			return;
		}
		this.value = event;
		if (this.oldValue != event || event.match(/[a-z]/i)) {
			if (this.control.attributes.pattern) {
				this.restrictPattern();
			}

			if (this.control.attributes.groupDigits && !this.isMobile) {
				this.groupDigits();
				this.addDollar();
			}

			this.updateAnswer();
		}
		this.el.nativeElement.querySelector('input').value = this.value;
		this.oldValue = this.value;
		this.reportEditedPrefillValue();
	}

	restrictPattern() {
		// Have value to handle
		if (this.value && this.value.toString().length > 0) {
			// Have value length limitations
			if (this.control.attributes.integersLength && this.control.attributes.decimalLength) {
				const intsLength = parseInt(this.control.attributes.integersLength);
				const decimalLength = parseInt(this.control.attributes.decimalLength);
				// Have valid length limitation values
				if (intsLength !== NaN && decimalLength !== NaN) {
					// Handle values with decimal places
					if (this.value.toString().indexOf('.') !== -1) {
						const splitValue = this.value.toString().split('.');
						let intValue = 0;
						let decimalValue = 0;

						// Current int value exceeds length limit
						if (splitValue[0].length > intsLength) {
							intValue = splitValue[0].substring(0, intsLength);
						} else {
							intValue = splitValue[0];
						}

						// Current decimal places exceeds length limit
						if (splitValue[1].length > decimalLength) {
							decimalValue = splitValue[1].substring(0, decimalLength);
						} else {
							decimalValue = splitValue[1];
						}

						this.value = intValue + '.' + decimalValue;
					} else {
						// Current value exeeds length limit
						if (this.value.toString().length > intsLength) {
							this.value = this.value.toString().substring(0, intsLength);
						}
					}
				}
				const newValArray = this.value.toString().match(this.restrictPatternRegex);
				if (newValArray === null) {
					this.value = this.value.toString().substring(0, this.value.length - 1);
				}
			}
		}

		if (!this.control.attributes.integersLength && !this.control.attributes.decimalLength) {
			if (!this.value) {
				return;
			}
			const newValArray = this.value.toString().match(this.restrictPatternRegex);
			this.value = (newValArray || []).join('');
		}
	}

	groupDigits() {
		if (this.value != undefined) {
			this.value = formatNumberWithCommas(this.value);
			const commasCount = this.value.split(',').length - 1;
			this.calculatedMaxlength = this.control.attributes.maxlength + commasCount;
			//calculate dollar as well
			this.calculatedMaxlength = this.control.attributes.addDollar
				? this.calculatedMaxlength + 1
				: this.calculatedMaxlength;
		}
	}

	addDollar() {
		if (this.value != undefined && this.control.attributes.addDollar) {
			this.value = this.value.indexOf('$') == -1 ? '$' + this.value : this.value;
			this.calculatedMaxlength = this.calculatedMaxlength + 1;
			//calculate commas as well
			if (this.control.attributes.groupDigits) {
				const commasCount = this.value.split(',').length - 1;
				this.calculatedMaxlength = this.calculatedMaxlength + commasCount;
			}
		}
	}

	removeMiddleNameError() {
		// Select the unmasked-input element that contains the MiddleName
		const middleNameInput = document.querySelector('unmasked-input.mname');

		// Select the form inside the unmasked-input element and remove the 'error' class
		if (middleNameInput) {
			const formElement = middleNameInput.querySelector('form');
			if (formElement && formElement.classList.contains('error')) {
				formElement.classList.remove('error');
			}

			// Select the error-container inside the unmasked-input and remove it
			const errorContainer = middleNameInput.querySelector('.error-container');
			if (errorContainer) {
				errorContainer.remove();
			}
		}
	}

	updateAnswer(toBebounce?: boolean) {
		this.truncNumber();
		// clean commas if groupDigits is set to  true
		const strippedValue = this.control.attributes.groupDigits ? this.stripCommas(this.value) : this.value;
		//clean dollar if addDollar is set to true
		const noDollarValue = this.control.attributes.addDollar ? this.deleteDollar(strippedValue) : strippedValue;
		if (this.control && this.control.ajaxInfo && this.control.ajaxInfo.debounce) {
			if (this.answerDebounce) {
				clearTimeout(this.answerDebounce);
			}
			if (toBebounce) {
				const debounce = this.control.ajaxInfo.debounce;
				this.answerDebounce = setTimeout(() => {
					this.setAnswer(noDollarValue);
					clearTimeout(this.answerDebounce);
				}, debounce);
			}
		} else {
			this.setAnswer(noDollarValue);
		}
	}

	stripCommas(value) {
		if (typeof value === 'undefined') {
			return value;
		}

		// remove regex matched chars from value
		return String(value).replace(/,/g, '');
	}

	deleteDollar(value) {
		if (typeof value === 'undefined') {
			return value;
		}

		// remove regex matched chars from value
		return String(value).replace('$', '');
	}

	onNumberInput(event) {
		const maxLength = this.control.attributes.maxlength;
		if (this.inputType === 'number') {
			if (this.value.length > maxLength) {
				this.el.nativeElement.querySelector('input').value = this.value.slice(0, maxLength);
			}
		}
	}

	truncNumber() {
		if (this.inputType === 'number') {
			if (this.value && this.value.length > this.calculatedMaxlength) {
				this.value = this.value.slice(0, this.calculatedMaxlength);
			}
		}
	}

	assignClass(control) {
		let cssClass;
		if (control.attributes !== undefined && control.attributes.class !== undefined) {
			cssClass = `${control.attributes.class}-input`;
		}

		if (this.value) {
			cssClass += ' filled';
		} else {
			cssClass += ' empty';
		}

		if (!!this.control.attributes.placeholder) {
			cssClass += ' has-placeholder';
		}
		return cssClass;
	}

	keypadClose() {
		if (this.isMobile) {
			this.el.nativeElement.querySelector('.masked-input').blur();
		}
	}
}
